import type { MantineColor, StyleProp } from '@mantine/core'
import type { OrderDetails } from '../../model/order.types'
import { Group, Stack, Text } from '@mantine/core'
import { IconChevronRight } from '@tabler/icons-react'
import clsx from 'clsx'
import React from 'react'
import styles from './OrderItemWithMetaInfo.module.css'

interface OrderItemWithMetaInfoProps {
  orderId: OrderDetails['orderId']
  bg?: StyleProp<MantineColor>
  customerName?: string
  emojiItems?: string[]
  className?: string
  onClick?: (e: React.MouseEvent, ...args: any) => void
}

export function OrderItemWithMetaInfo({
  bg,
  customerName,
  orderId,
  emojiItems,
  className,
  onClick,
}: OrderItemWithMetaInfoProps) {
  return (
    <Group
      className={clsx(styles.orderItemWithMetaInfo, className)}
      bg={bg}
      wrap="nowrap"
      gap={4}
      py={6}
      px={8}
      data-testid="order-item"
      onClick={(e: React.MouseEvent) => onClick?.(e, orderId)}
      tabIndex={0}
    >
      <Stack className={styles.textContainer}>
        <Text
          span
          className={styles.customerName}
          c="gray.8"
          fw={700}
          lh="normal"
        >
          {customerName}
        </Text>
        <Text
          span
          size="sm"
          lh="normal"
          className={styles.orderIdTruncate}
        >
          {orderId}
        </Text>
      </Stack>

      {emojiItems?.length && (
        <Stack justify="center" align="center" className={styles.emojiContainer}>
          <Text span className={styles.emojiText}>
            {emojiItems.join('')}
          </Text>
        </Stack>
      )}

      <IconChevronRight size={24} />
    </Group>
  )
}
